import styled, { AnyStyledComponent, css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'
import Offer from '../../../assets/icons/offer-badge.svg'
import { getBasePath } from '../../../utils/miscellaneous-utils'
import FreeCancellation from '../../../assets/icons/free-cancellation-shield.svg'
import { GreenTickIcon } from '../../common/icons'
import FullStar from '../../../assets/icons/star.svg'

export const CTAButton = styled.button`
    width: 100%;
    padding: 0.5rem 1.5rem;
    border-radius: 0.75rem;
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5rem;
    cursor: pointer;
    text-align: center;
    border: 0.0625rem solid transparent;

    background-color: ${({ theme }) => theme.colors.tfwYellow};
    color: ${({ theme }) => theme.colors.tfwBlack99};

    &:hover {
        background-color: ${({ theme }) => theme.colors.tfwYellowHover};
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
    }

    &:active {
        transform: translateY(0.0625rem);
    }
`

export const BreadcrumbContainer = styled.div`
    margin-bottom: 1rem;
`

export const OuterCardWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        background-color: transparent;
        gap: ${theme.spacing.xSmall};
        padding: 0 0 1.5rem 0;
        margin-bottom: 1.5rem;
        border-bottom: ${theme.typography.border.width.xxxThin} ${theme.typography.border.style.solid}
            ${theme.colors.tfwBlackOpacity10};
        cursor: pointer;
    `,
)

export const CardContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 1rem;
    column-gap: 1.25rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        grid-template-columns: 20rem 1fr;
        align-items: stretch;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        grid-template-columns: 18rem 1fr;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        grid-template-columns: 24rem 1fr;
    }
`

export const ImageSection = styled.div(
    ({ theme }) => css`
        border-radius: 1rem;
    `,
)

export const ImageWrapper = styled.div`
    position: relative;
    border-radius: 1rem;
    overflow: hidden;
`

export const NextImageContainer = styled.div`
    height: 100%;
    width: 100%;

    > div {
        border-radius: 1rem;
    }
`

export const FavoriteButton = styled.div(
    ({ theme }) => css`
        position: absolute;
        top: 0;
        right: 0;
        width: 3.5rem;
        height: 3.5rem;
        background: radial-gradient(100% 100% at 100% 0%, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
        border-radius: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
)

export const WishlistIconContainer = styled.div`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
`

export const ContentSection = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        color: ${theme.colors.tfwBlack99};
        padding: 0 1rem;
        overflow: hidden;
    `,
)

export const FeaturesWrapper = styled.div`
    margin-top: 0.25rem;
`

export const Title = styled.h2(
    ({ theme }) => css`
        margin: 0;
        width: 100%;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 1.25rem;
        line-height: 1.75rem;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
)

export const StatsRow = styled.div(
    ({ theme }) => css`
        font-size: 0.875rem;
        line-height: 1.375rem;
        color: #282828;
    `,
)

export const RatingWrapper = styled.div`
    display: flex;
    align-items: center;
`

export const RatingRow = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing.xxSmall};
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.875rem;
        color: ${theme.colors.tfwBlack99};
    `,
)

export const RatingText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.875rem;
        line-height: 1.375rem;
        color: #282828;
    `,
)

export const RatingCount = styled.span(
    ({ theme }) => css`
        font-size: 0.875rem;
        line-height: 1.375rem;
        color: #5f5f5f;
    `,
)

export const FullStarIcon = styled(FullStar as AnyStyledComponent)`
    margin-right: 0.312rem;
`

export const DTVSeparator = styled.div`
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    background-color: #282828;
    margin: 0 0.5rem;
    align-self: center;
    flex-shrink: 0;
`

export const TooltipContainer = styled.div`
    position: absolute;
    bottom: 150%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: normal;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0.2s;
    z-index: 10;
    width: max-content;
    max-width: 200px;
    text-align: center;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #333 transparent transparent transparent;
    }
`

export const DTVContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;

    &:hover ${TooltipContainer} {
        opacity: 1;
        visibility: visible;
    }
`

export const DTVStarContainer = styled.div`
    display: flex;
`

export const DTVRatingText = styled.span`
    display: flex;
    flex-shrink: 0;
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: 0.75rem;
    line-height: 1rem;
    color: #282828;
`

export const DTVImage = styled.img`
    width: 2rem;
    height: 0.6875rem;
    object-fit: contain;
    margin-left: 0.25rem;
`

export const DTVLabel = styled.span`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: 0.75rem;
    line-height: 1.375rem;
    color: #6f6f6f;
    margin-left: 0.25rem;
`

export const Description = styled.p(
    ({ theme }) => css`
        margin-top: ${theme.spacing.xSmall};
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.875rem;
        color: ${theme.colors.tfwBlack99};
        line-height: 1.4;
    `,
)

export const BookingHighlights = styled.div`
    display: flex;
    margin-top: 0.25rem;
    gap: 0.5rem;
`

export const QuickResponderTag = styled.div`
    display: inline-flex;
    align-items: center;
    color: #0d7c4f;
    font-size: 0.75rem;
    line-height: 1rem;
`

export const StyledFastResponderIcon = styled(GreenTickIcon)`
    width: 0.75rem;
    height: 0.75rem;
    margin-right: 0.5rem;
    vertical-align: middle;
`

export const BottomRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    margin-top: auto;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
        margin-top: 1rem;
    }
`

export const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
`

export const ButtonWrapper = styled.div`
    min-width: 8rem;
    flex-shrink: 0;
`

export const ObjectTopRecommendationPill = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0rem;
        right: 0rem;
        width: 4.5rem;
        height: 3.5rem;
        background: radial-gradient(100% 100% at 100% 100%, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
        justify-content: center;
    `,
)

export const TopRecommendationWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 0.625rem;
        line-height: 0.75rem;
        color: #ffffff;
        position: absolute;
        bottom: 0.5rem;
        right: 0.5rem;
    `,
)

export const PriceContainer = styled.div`
    display: flex;
    flex-direction: column-reverse;

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        flex-direction: row;
    }
`

export const PriceText = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 600;
        font-size: 1.25rem;
        line-height: 1.75rem;
        color: #282828;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) and (max-width: ${wideScreenBreakpoint.min}px) {
            font-size: 1rem;
            line-height: 1.5rem;
        }
    `,
)

export const PersonDetails = styled.div(
    ({ theme }) => css`
        display: flex;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1rem;
        color: #5f5f5f;
        margin: 0.25rem 0 0;
    `,
)

export const CheckBoxLabel = styled.label`
    padding: 0.5rem;
    display: inline-block;
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 100%;
    outline: 0;
    background-color: white;
    border-radius: 0.3rem;
`

const checkBoxUrl = `url(${getBasePath('/assets/icons/white-check.svg')})`

export const InputCheckbox = styled.input`
    &:checked + ${CheckBoxLabel} {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: ${props => props.theme.colors.tfwBlack99} ${checkBoxUrl} no-repeat center;
        background-size: 1rem;
    }

    display: none;
`

export const CheckBox = styled.div`
    width: 1.5rem;
    height: 1.5rem;
`

export const InformationWrapper = styled.div`
    display: ${props => props.theme.style.display.flex};
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    z-index: 20;
    width: 1.5rem;
    height: 1.5rem;
`

export const LocationContainer = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        gap: 0.25rem;
    `,
)

export const LocationText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.75rem;
        line-height: 1rem;
        color: #6c6c6c;
        font-weight: 400;
    `,
)

export const SeoHref = styled.a`
    display: flex;
    font: inherit;
    text-decoration: none;
`

export const ContentHeader = styled.div(
    ({ theme }) => css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 0.5rem;
    `,
)

export const RegionTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    gap: 0.25rem;
`

export const PopularChoiceTagContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
`

export const PopularChoiceTagText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.75rem;
        line-height: 1rem;
        font-weight: 600;
        color: #8f6408;
    `,
)

export const TraumTagIconStyled = styled.svg`
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
`

export const TopTraumTagPill = styled.div<{ $showCheckbox?: boolean }>(
    ({ theme, $showCheckbox }) => css`
        display: flex;
        align-items: center;
        gap: 0.25rem;
        position: absolute;
        top: ${$showCheckbox ? '0.75rem' : '0.5rem'};
        left: ${$showCheckbox ? '3rem' : '0.5rem'};
        border-radius: 1rem;
        background-color: #ffffffcc;
        padding: 0.25rem 0.5rem;
    `,
)

export const TraumTagLabel = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.75rem;
        line-height: 1rem;
        font-weight: 400;
        color: #282828;
    `,
)

export const OfferPriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

export const OfferBadge = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        width: fit-content;
        min-width: 10.25rem;
        background: linear-gradient(90deg, #d2faea 0%, #ffffff 100%);
        padding: 0.25rem 0.5rem;
        border-radius: 12px;
        border-left: 2px solid var(--colour-border-intense-positive, #0d7c4f);
    `,
)

export const OfferIcon = styled(Offer as AnyStyledComponent)`
    width: 1rem;
    height: 1rem;
    margin-right: 0.25rem;
`

export const OfferText = styled.span`
    color: #0d7c4f;
    font-size: 0.875rem;
    line-height: 1.375rem;
    font-weight: 400;
`

export const FreeCancellationContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        margin-left: 0.5rem;
    }
`

export const FreeCancellationIcon = styled(FreeCancellation as AnyStyledComponent)`
    width: 1.25rem;
    height: 1.25rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${wideScreenBreakpoint.min}px) {
        width: 1rem;
        height: 1rem;
    }
`

export const FreeCancellationText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.375rem;
        color: #282828;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${wideScreenBreakpoint.min}px) {
            font-size: 0.75rem;
            line-height: 1rem;
        }
    `,
)

export const OfferWrapper = styled.div``

export const BottomTraumTagContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    justify-content: center;
    height: 100%;
    background: linear-gradient(190.38deg, #ffffff 40.45%, #eee3ff 100%);
    padding: 0.5rem;
    border-radius: 0 0 1rem 1rem;
`

export const BottomTraumTagImage = styled.img`
    width: 1.5rem;
    height: 1.5rem;
    object-fit: contain;
`

export const BottomTraumTagText = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 0.875rem;
        line-height: 1.375rem;
        font-weight: 600;
        color: #8f6408;
    `,
)

export const PartnerLogoContainer = styled.div<{ $partnerName: string }>(
    ({ theme, $partnerName }) => css`
        position: absolute;
        top: ${theme.spacing.small};
        right: ${theme.spacing.small};
        background-color: #fff;
        border-radius: ${$partnerName === 'holidu' ? '0.5rem' : '0.25rem'};
        padding: ${$partnerName === 'holidu' ? '0.25rem' : '0.25rem 0.5rem'};
        display: flex;
        align-items: center;
        justify-content: center;
    `,
)

export const PartnerLogo = styled.img<{ $partnerName: string }>(
    ({ $partnerName }) => css`
        width: ${$partnerName === 'holidu' ? '4.5rem' : '3rem'};
        height: auto;
        object-fit: contain;
    `,
)
